export const FORWARD_BTN_LABEL = 'ส่งต่อ'
export const CLOSE_BTN_LABEL = 'ดำเนินการเสร็จสิ้น'